import React, { useEffect, useState } from "react";
import AgGridTable from "../../components/controls/AgGridTable";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../contexts/AuthContext";
import OrderDetailsModal from "./OrderDetailsModal";

const SupplierOrdersPage = () => {
  const { t } = useTranslation();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { currentUser } = useAuth();
  const userId = currentUser?.id;

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/Order/ForProvider/${userId}`
        );
        const data = await response.json();
        setOrders(data);
      } catch (error) {
        console.error("Error fetching supplier orders:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [userId]);

  const columnDefs = [
    { headerName: t("orderId"), field: "id", hide: true },
    {
      headerName: t("stepOne.eventDate.label"),
      field: "eventDate",
      sortable: true,
      filter: true,
      cellRenderer: (params) => new Date(params.value).toLocaleDateString(),
    },
    {
      headerName: t("cart.eventAddress"),
      field: "eventLocationFormatted",
      sortable: true,
      filter: true,
      cellRenderer: (params) => {
        if (!params.value) return "";

        const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
          params.value
        )}`;

        return React.createElement(
          "a",
          {
            href: googleMapsUrl,
            target: "_blank",
            rel: "noopener noreferrer",
            style: { color: "#007BFF", textDecoration: "underline" },
          },
          params.value
        );
      },
    },

    {
      headerName: t("cart.totalPrice"),
      field: "totalAmount",
      sortable: true,
      filter: true,
      valueFormatter: (params) => `${params.value.toFixed(2)} $`,
    },
    {
      headerName: t("providers.customerName"),
      field: "customerName",
      sortable: true,
      filter: true,
    },
    {
      headerName: t("becomeProvider.phoneNumberLabel"),
      field: "contactPhone",
      sortable: true,
      filter: true,
    },
    {
      headerName: t("providerRequestsGrid.actions"),
      field: "actions",
      cellRenderer: (params) => (
        <button
          onClick={() => openModal(params.data)}
          className="bg-primary text-white px-4 py-2 rounded-full hover:bg-accent transition h-full flex items-center justify-center"
          style={{ height: "100%" }}
        >
          {t("providerRequestsGrid.viewDetails")}
        </button>
      ),
    },
  ];

  const openModal = (order) => {
    setSelectedOrder(order);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedOrder(null);
    setIsModalOpen(false);
  };

  return (
    <div style={{ padding: "20px" }}>
      <h1 className="text-onWhite font-bold text-2xl">
        {t("providers.orders")}
      </h1>

      {loading ? (
        <p>{t("loading")}</p>
      ) : (
        <AgGridTable
          columnDefs={columnDefs}
          rowData={orders}
          pagination={true}
        />
      )}

      {isModalOpen && selectedOrder && (
        <OrderDetailsModal
          isOpen={isModalOpen}
          onClose={closeModal}
          order={selectedOrder}
        />
      )}
    </div>
  );
};

export default SupplierOrdersPage;
